// extracted by mini-css-extract-plugin
var _1 = "SearchInput-module__animatedBackground--YISZI";
var _2 = "SearchInput-module__container--kdR2o";
var _3 = "SearchInput-module__icon--a7P_k";
var _4 = "SearchInput-module__input--KqeOj";
export { _1 as "animatedBackground", _2 as "container", _3 as "icon", _4 as "input" }
